import Sondaggio from "../../views/survey/Index";

export default [
    {
        path: '/sondaggio',
        name: 'sondaggio',
        component: Sondaggio,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'ristorante_sondaggio' }
    }
]
